/**
 * KAHVE KAVURMA MERKEZİ — Dil / Metin Dosyası
 * assets/kahve-lang.js
 *
 * Tüm arayüz metinlerini buradan düzenleyebilirsiniz.
 */
window.KW_LANG = {

  /* ── Adım nav etiketleri ── */
  nav: {
    step1: 'TÜR',
    step2: 'HARMAN',
    step3: 'ÇEKİRDEK',
    step4: 'KAVURMA',
    step5: 'AMBALAJ',
    step6: 'ADET',
    step7: 'ÖNİZLEME',
  },

  /* ── Adım başlıkları ── */
  steps: {
    1: {
      eyebrow: 'ADIM 1 / 8',
      title:   'Kullanım alanını seçin',
      desc:    'Kahvenin kullanılacağı demleme ekipmanına göre seçiminizi yapın.',
    },
    2: {
      eyebrow: 'ADIM 2 / 8',
      title:   'Çekirdek yapısını belirleyin',
      desc:    'İşletmenizin kahve profiline uygun yapıyı seçin.',
    },
    3: {
      eyebrow: 'ADIM 3 / 8',
      title:   'Yeşil çekirdek seçimi',
      desc:    'Seçilen çekirdekler; gövde, aroma yapısı ve içim karakterini doğrudan etkiler.',
    },
    4: {
      eyebrow: 'ADIM 4 / 8',
      title:   'Kavurma profili ve öğütme',
      desc:    'Kavurma derecesi; gövde, aroma yoğunluğu ve içim yapısını doğrudan etkiler.',
    },
    5: {
      eyebrow: 'ADIM 5 / 8',
      title:   'Üretim miktarını belirleyin',
      desc:    'İhtiyacınıza uygun kilogram aralığını seçin.',
    },
    6: {
      eyebrow: 'ADIM 6 / 8',
      title:   'Paket dağılımını belirleyin',
      desc:    'Ambalaj boyutunu ve adet dağılımını belirleyin.',
    },
    7: {
      eyebrow: 'ADIM 7 / 8',
      title:   'Ambalaj tercihi',
      desc:    'Her paket boyutu için ambalaj tipini ayrı ayrı belirleyebilirsiniz.',
    },
    8: {
      eyebrow: 'ADIM 8 / 8',
      title:   'Sipariş önizleme',
      desc:    'Tüm seçimlerinizi gözden geçirin. Kahveler sipariş bazlı kavrulurak hazırlanır.',
    },
  },

  /* ── Kahve türleri ── */
  types: {
    turk: {
      title: 'Türk Kahvesi',
      desc:  'Markanıza özel Türk kahvesi profilinizi tamamen sizin tercihleriniz doğrultusunda oluşturuyoruz. Çekirdek seçimi, harman yapısı, kavurma derecesi ve içim karakterini belirleyerek işletmenize özel üretim gerçekleştiriyoruz.',
    },
    filtre: {
      title: 'Filtre Kahve',
      desc:  'Filtre kahvenizi kullanım alanınıza ve demleme ekipmanınıza uygun şekilde birlikte şekillendiriyoruz. Endüstriyel filtre kahve makineleri, V60, pour over ve French press kullanımına özel; çekirdek yapısı, kavurma profili ve aroma karakterini sizin tercihleriniz doğrultusunda hazırlıyoruz.',
    },
    espresso: {
      title: 'Espresso',
      desc:  'Espresso harmanınızı tamamen kendi servis profilinize göre oluşturun. Çekirdek yapısından kavurma derecesine, gövde yoğunluğundan aroma karakterine kadar tüm detayları belirleyin; kafenize ve ekipmanınıza özel espresso üretimini sizin için gerçekleştirelim.',
    },
  },

  /* ── Karakter seçimi ── */
  character: {
    single: {
      title: 'Single Origin',
      desc:  'Tek bir orijine ait çekirdeklerle, bölgenin karakteristik aroma ve tat profilini ön plana çıkarın.',
      badge: '1 adet yeşil çekirdek seçilecektir.',
    },
    blend: {
      title: 'Blend (Harman)',
      desc:  'Farklı orijinlerin dengesi. Gövde, asit ve tatlılığı özel oranda birleştirin.',
      badge: '2 veya 3 yeşil çekirdek + oran seçeceksiniz.',
    },
  },

  /* ── Kavurma dereceleri ── */
  roast: {
    light:    {
      title: 'Light',
      desc:  'Açık kavrum; çiçeksi ve meyvemsi notalar öne çıkar.',
      time:  '9–10 dk',
    },
    medium:   {
      title: 'Medium',
      desc:  'Dengeli asit ve tatlılık; kahvenin orijin karakteri net.',
      time:  '11–12 dk',
    },
    fullCity: {
      title: 'Full City',
      desc:  'İlk çıtırtı sonu; karamelize edilmiş tatlılık, yoğun gövde.',
      time:  '12–13 dk',
    },
    dark:     {
      title: 'Dark',
      desc:  'Koyu kavrum; çikolata, tütün ve yanık şeker notaları.',
      time:  '14+ dk',
    },
  },

  /* ── Tasarım seçimi ── */
  design: {
    generic: { title:'Standart Tasarım',   desc:'Kahve Kavurma Merkezi marka ambalajı. Hazır ve hızlı.' },
    custom:  { title:'Özel Marka', priceBadge:'+25 ₺/paket', desc:'Logonuzu yükleyin, kendi markanızla gönderelim.' },
  },

  /* ── Özet paneli ── */
  summary: {
    title:        'Özetiniz',
    label:        'SİPARİŞİNİZ',
    type:         'KAHVE TÜRÜ',
    character:    'KARAKTER',
    roast:        'KAVURMA',
    qty:          'MİKTAR',
    packages:     'AMBALAJ',
    beans:        'ÇEKİRDEKLER',
    total:        'Tahmini Toplam',
    complete:     'Adımları Tamamlayın',
    completeNote: 'Tüm seçimleri yapınca onay butonu aktifleşir.',
    saveBlend:    '💾 Harmanı kaydet',
    savedTitle:   'KAYITLI HARMANLARIM',
    savedEmpty:   'Henüz kayıtlı harmanınız bulunmuyor.',
    resetBtn:     'Baştan Başla',
    resetConfirm: 'Tüm seçimler silinecek ve 1. adıma döneceksiniz. Emin misiniz?',
  },

  /* ── Oran / Harman ── */
  ratio: {
    title: 'Harman oranları',
    hint:  'Bar üzerindeki tutamakları sürükleyerek oranları değiştirebilirsiniz.',
    note:  'Her çekirdek en az %10, en çok %80 olabilir.',
    total: 'Toplam:',
  },

  /* ── Preset ── */
  preset: {
    title: 'Hazır tariflerimizden hızlıca başlayın',
    desc:  'Aşağıdaki önerilerden birini seçerek çekirdek, oran ve kavurma ayarlarını atlayın — doğrudan ambalaj seçimine geçersiniz.',
  },

  /* ── Miktar ── */
  qty: {
    plusLabel: '100+ kg',
  },

  /* ── Paket ── */
  pkg: {
    progress:     'Tamamlandı',
    warning_more: 'daha eklemeniz gerekiyor.',
    warning_over: 'fazla seçtiniz, azaltın.',
    logoUpload:   'Logo dosyasını buraya bırakın veya tıklayın',
    logoHint:     'PNG, SVG veya PDF · Maksimum 10 MB',
    logoChange:   '↺ Logoyu Değiştir',
  },

  /* ── Navigasyon butonları ── */
  nav_btns: {
    back:    '← Geri',
    next:    'Devam →',
    addCart: 'Sepete Ekle',
    buyNow:  'Hemen Satın Al →',
  },

  /* ── Popup / modal ── */
  contact: {
    title:      'Büyük Hacimli Sipariş',
    desc:       '100 kg ve üzeri siparişler için bilgilerinizi bırakın, en kısa sürede sizi arayalım.',
    namePh:     'Adınız Soyadınız',
    phonePh:    'Telefon Numaranız',
    kgPh:       'Tahmini miktar (kg)',
    submit:     'Talebi Gönder',
    successMsg: 'Teşekkürler! Talebiniz alındı, en kısa sürede sizi arayacağız.',
    validation: 'Lütfen tüm alanları doldurun.',
  },

  /* ── Uyarı metinleri ── */
  warnings: {
    leaveConfirm:  'Sipariş oluşturma işleminiz kaybolacak. Çıkmak istiyor musunuz?',
    demoMode:      'Demo moddasınız. Shopify koleksiyonlarını kurduktan sonra gerçek sipariş alınabilir.',
    stockError:    'için stok yetersiz.',
    pkgStockError: 'ambalajı için stok yetersiz.',
    beanSelectNone:'En az 2 çekirdek seçin.',
    beanSelectOne: 'Bir çekirdek daha seçin (min 2, maks 3).',
    ratioNotFull:  'Oranların toplamı',
    ratioNotFull2: '— devam etmek için %100 olmalı.',
    logoMaxSize:   'Maksimum dosya boyutu 10 MB\'dır.',
    cartError:     'Sepete eklenirken hata oluştu:',
    blendSaved:    'Harmanınız kaydedildi!',
    blendLoginReq: 'Harman kaydetmek için giriş yapın.',
    contactFields: 'Lütfen tüm alanları doldurun.',
  },

  /* ── Boş durum / yükleme ── */
  misc: {
    loading:      'Yükleniyor…',
    noBeansFound: 'Bu demleme türü için uygun çekirdek bulunamadı.',
    empty:        '—',
    unit_kg:      'kg',
    unit_gr:      'gr',
  },

  /* ── Değer etiketleri ── */
  labels: {
    filtre:   'Filtre Kahve',
    turk:     'Türk Kahvesi',
    espresso: 'Espresso',
    single:   'Single Origin',
    blend:    'Blend (Harman)',
    light:    'Light',
    medium:   'Medium',
    fullCity: 'Full City',
    dark:     'Dark',
  },
};